/* Parwin per-variant gallery.
   Desktop: thumbnail strip. Mobile: dots navigation + swipe.
   Swaps a full image set when the variant changes via the theme's native
   'variant:update' event (e.detail.resource.id). No external libraries. */
(function () {
  function indexOfEl(list, el) { return Array.prototype.indexOf.call(list, el); }

  function setIndex(panel, idx) {
    var dots = panel.querySelectorAll('.pvg__dot');
    var thumbs = panel.querySelectorAll('.pvg__thumb');
    var n = dots.length || thumbs.length;
    if (!n) return;
    if (idx < 0) idx = 0;
    if (idx >= n) idx = n - 1;
    var src = null;
    if (dots[idx]) src = dots[idx].getAttribute('data-full');
    else if (thumbs[idx]) src = thumbs[idx].getAttribute('data-full');
    var main = panel.querySelector('.pvg__main-img');
    if (main && src) main.src = src;
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    panel.__idx = idx;
  }

  function initRoot(root) {
    if (root.__pvgInit) return;
    root.__pvgInit = true;

    // Click on a thumbnail (desktop) or a dot (mobile)
    root.addEventListener('click', function (e) {
      var dot = e.target.closest('.pvg__dot');
      var thumb = e.target.closest('.pvg__thumb');
      var hit = dot || thumb;
      if (!hit || !root.contains(hit)) return;
      var panel = hit.closest('.pvg__panel');
      if (!panel) return;
      if (dot) setIndex(panel, indexOfEl(panel.querySelectorAll('.pvg__dot'), dot));
      else setIndex(panel, indexOfEl(panel.querySelectorAll('.pvg__thumb'), thumb));
    });

    // Swipe on the main image (mobile)
    root.querySelectorAll('.pvg__panel').forEach(function (panel) {
      var main = panel.querySelector('.pvg__main');
      if (!main) return;
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (ev) {
        var t = ev.touches[0]; x0 = t.clientX; y0 = t.clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (ev) {
        if (x0 === null) return;
        var t = ev.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          var cur = panel.__idx || 0;
          setIndex(panel, dx < 0 ? cur + 1 : cur - 1);
        }
        x0 = null; y0 = null;
      }, { passive: true });
    });
  }

  function showVariant(root, id) {
    root.querySelectorAll('.pvg__panel[data-variant-id]').forEach(function (p) {
      var match = p.getAttribute('data-variant-id') === String(id);
      p.hidden = !match;
      p.classList.toggle('is-active', match);
    });
  }

  function ready() {
    document.querySelectorAll('variant-gallery.pvg').forEach(initRoot);
  }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);

  document.addEventListener('variant:update', function (e) {
    var id = e.detail && e.detail.resource && e.detail.resource.id;
    if (!id) return;
    document.querySelectorAll('variant-gallery.pvg').forEach(function (root) {
      initRoot(root);
      showVariant(root, id);
    });
  });
})();
